(() => {
  const configElement = document.getElementById('MatVolumeConfig');
  if (!configElement) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.error('Unable to read mat volume discount configuration:', error);
    return;
  }

  const variantIds = new Set(config.variantIds.map(String));
  const root = window.Shopify?.routes?.root || '/';
  let pending = Promise.resolve();

  async function requestCart(path, body) {
    const response = await fetch(`${root}${path}`, {
      method: body ? 'POST' : 'GET',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });
    const cart = await response.json();
    if (!response.ok || cart.errors || cart.status >= 400) {
      throw new Error(cart.description || cart.message || `Mat cart request failed (${response.status}).`);
    }
    return cart;
  }

  function getCodes(cart) {
    return [...new Set((cart.discount_codes || []).map((entry) => entry.code).filter(Boolean))];
  }

  function getSections() {
    const sections = ['cart-icon-bubble'];
    if (document.getElementById('CartDrawer')) sections.push('cart-drawer');
    for (const id of ['main-cart-items', 'main-cart-footer']) {
      const section = document.getElementById(id)?.dataset.id;
      if (section) sections.push(section);
    }
    return [...new Set(sections)].slice(0, 5);
  }

  async function synchronize(sections = getSections(), suppliedCart) {
    const cart = await requestCart('cart.js');
    const codes = getCodes(cart);
    const hasMats = cart.items.some((item) => variantIds.has(String(item.variant_id)) && item.quantity > 0);
    const hasCode = codes.some((code) => code.toUpperCase() === config.code);
    if (!hasMats && !hasCode) return { ...cart, sections: suppliedCart?.sections };

    const nextCodes = codes.filter((code) => code.toUpperCase() !== config.code);
    if (hasMats) nextCodes.push(config.code);
    // Persist on Shopify, then use the sections returned after its recalculation.
    return requestCart('cart/update.js', {
      discount: nextCodes.join(','),
      sections,
      sections_url: window.location.pathname,
    });
  }

  function sync(sections, cart) {
    const previous = pending;
    const operation = (async () => {
      try {
        await previous;
      } catch {
        // The caller reports failures; a failed request must not block later updates.
      }
      return synchronize(sections, cart);
    })();
    pending = operation;
    return operation;
  }

  function render(cart) {
    const targets = [
      ['cart-drawer', '#CartDrawer .drawer__inner'],
      ['cart-icon-bubble', '#cart-icon-bubble'],
      ...['main-cart-items', 'main-cart-footer'].map((id) => [document.getElementById(id)?.dataset.id, `#${id} .js-contents`]),
    ];
    for (const [section, selector] of targets) {
      const html = cart.sections?.[section];
      const target = document.querySelector(selector);
      if (!html || !target) continue;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = parsed.querySelector(selector) || parsed.querySelector('.shopify-section');
      if (source) target.innerHTML = source.innerHTML;
    }
    document.querySelector('cart-drawer')?.classList.toggle('is-empty', cart.item_count === 0);
  }

  window.GymSetsMatVolume = { sync, getCodes, getSections, render };

  // Native cart checkout must wait for the real cart code, including restored carts.
  const allowedForms = new WeakSet();
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const submitter = event.submitter;
    if (submitter?.name !== 'checkout' || form.closest('product-form') || allowedForms.has(form)) return;
    event.preventDefault();
    if (form.dataset.matVolumePending === 'true') return;
    form.dataset.matVolumePending = 'true';
    submitter.disabled = true;
    try {
      await sync();
      allowedForms.add(form);
      submitter.disabled = false;
      form.requestSubmit(submitter);
    } catch (error) {
      console.error('Unable to synchronize mat volume discount before checkout:', error);
      const errors = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
      if (errors) errors.textContent = window.cartStrings?.error || error.message;
    } finally {
      submitter.disabled = false;
      delete form.dataset.matVolumePending;
      allowedForms.delete(form);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', async () => {
    try {
      render(await sync());
    } catch (error) {
      console.error('Unable to restore mat volume discount on the cart:', error);
    }
  });
})();
